import { WebMarkerService } from './web';
export default WebMarkerService;
